<!-- 文档权限 -->
<template>
  <div class="rolePermission">
    <el-table :data="tableData" :show-header="false" :cell-style="cellStyle" border>
      <el-table-column width="160px" fixed>
        <template #default="{ row }">
          <el-checkbox v-model="row.$selectAll" :true-label="1" :false-label="0" :title="row.name"
            @change="selectAll(row)">
            {{ row.name }}
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column min-width="800px">
        <!-- roleType  1 设计区  2 提资区  3 成品区  企业级文档权限-->
        <!-- roleType  1630981681702设计区  1630981803194提资区  1630981811371 成品区    项目级文档权限-->
        <!-- 接口不一样 -->
        <template #default="{ row }">
          <el-checkbox v-model="row.$show" :true-label="1" :false-label="0" @change="showDown(row)">
            可见
          </el-checkbox>
          <el-checkbox v-model="row.$down" :true-label="1" :false-label="0" @change="downShow(row)">
            可下载
          </el-checkbox>
          <el-checkbox v-if="roleType!=='1630981803194'&&roleType!=='2'" v-model="row.fileNew" :true-label="1"
            :false-label="0" @change="isSelect(row,row.fileNew,'fileNew')">
            上传
          </el-checkbox>
          <el-checkbox v-model="row.folderNew" :true-label="1" :false-label="0" @change="isSelect(row,row.folderNew,'folderNew')">
            新建文件夹
          </el-checkbox>
          <el-checkbox v-model="row.fileDel" :true-label="1" :false-label="0" @change="isSelect(row,row.fileDel,'fileDel')">
            删除
          </el-checkbox>
          <el-checkbox v-if="roleType==='1630981681702'||roleType==='1'" v-model="row.isSubmit" :true-label="1"
            :false-label="0" @change="isSelect(row,row.isSubmit,'isSubmit')">
            提资准备
          </el-checkbox>
          <el-checkbox v-if="roleType==='1630981681702'||roleType==='1'" v-model="row.isPlaceFile" :true-label="1"
            :false-label="0" @change="isSelect(row,row.isPlaceFile,'isPlaceFile')">
            归档
          </el-checkbox>
          <el-checkbox v-if="roleType==='1630981681702'||roleType==='1'" v-model="row.isPrint" :true-label="1"
            :false-label="0" @change="isSelect(row,row.isPrint,'isPrint')">
            打印非正式图纸
          </el-checkbox>
          <el-checkbox v-if="roleType==='1630981811371'||roleType==='3'" v-model="row.isPrint" :true-label="1"
            :false-label="0" @change="isSelect(row,row.isPrint,'isPrint')">
            成品打印
          </el-checkbox>
          <el-checkbox v-model="row.isSnapshot" :true-label="1" :false-label="0" @change="isSelect(row,row.isSnapshot,'isSnapshot')">
            设置快照
          </el-checkbox>
          <el-checkbox v-model="row.isPriviSet" :true-label="1" :false-label="0" @change="isSelect(row,row.isPriviSet,'isPriviSet')">
            权限分配
          </el-checkbox>
          <el-checkbox v-model="row.priviAll" :true-label="1" :false-label="0" @change="isSelect(row,row.priviAll,'priviAll')">
            重命名
          </el-checkbox>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      required: false,
      default: () => []
    },
    roleType: {
      type: String,
      required: false,
      default: ""
    },
    checked: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    selectAll(row) {
      if (!this.checked) {
        if (row.$selectAll === 1) {
          row.$show = 1;
          row.$down = 1;
          row.fileNew = 1;
          row.folderNew = 1;
          row.fileDel = 1;
          row.isSubmit = 1;
          row.isPlaceFile = 1;
          row.isPrint = 1;
          row.isPriviSet = 1;
          row.priviAll = 1;
          row.isSnapshot = 1;
        } else {
          row.$show = 0;
          row.$down = 0;
          row.fileNew = 0;
          row.folderNew = 0;
          row.fileDel = 0;
          row.isSubmit = 0;
          row.isPlaceFile = 0;
          row.isPrint = 0;
          row.isPriviSet = 0;
          row.priviAll = 0;
          row.isSnapshot = 0;
        }
      } else {
        if (row.$selectAll === 1) {
          this.tableData.forEach(ele => {
            ele.$selectAll = 1;
            ele.$show = 1;
            ele.$down = 1;
            ele.fileNew = 1;
            ele.folderNew = 1;
            ele.fileDel = 1;
            ele.isSubmit = 1;
            ele.isPlaceFile = 1;
            ele.isPrint = 1;
            ele.isPriviSet = 1;
            ele.priviAll = 1;
            ele.isSnapshot = 1;
          });
        } else {
          this.tableData.forEach(ele => {
            ele.$selectAll = 0;
            ele.$show = 0;
            ele.$down = 0;
            ele.fileNew = 0;
            ele.folderNew = 0;
            ele.fileDel = 0;
            ele.isSubmit = 0;
            ele.isPlaceFile = 0;
            ele.isPrint = 0;
            ele.isPriviSet = 0;
            ele.priviAll = 0;
            ele.isSnapshot = 0;
          });
        }
      }
    },
    // 可见与可下载数据处理
    showDown(row) {
      if (!this.checked) {
        if (row.$show === 0) {
          row.$down = 0;
          row.$selectAll = 0;
        } else if (this.designArea(row)) {
          row.$selectAll = 1;
        } else if (this.carryInfoArea(row)) {
          row.$selectAll = 1;
        } else if (this.becomeProductArea(row)) {
          row.$selectAll = 1;
        }
      } else {
        if (row.$show === 0) {
          this.tableData.forEach(ele => {
            ele.$show = 0;
            ele.$down = 0;
            ele.$selectAll = 0;
          });
        } else {
          this.tableData.forEach(ele => {
            ele.$show = 1;
            if (this.designArea(ele)) {
              ele.$selectAll = 1;
            } else if (this.carryInfoArea(ele)) {
              ele.$selectAll = 1;
            } else if (this.becomeProductArea(ele)) {
              ele.$selectAll = 1;
            }
          });
        }
      }
    },
    downShow(row) {
      if (!this.checked) {
        if (row.$down === 1 && row.$show === 0) {
          row.$show = 1;
          // 如果勾选下载的时候 可见没有被勾选 则把可见给勾选上
          if (this.designArea(row)) {
            row.$selectAll = 1;
          } else if (this.carryInfoArea(row)) {
            row.$selectAll = 1;
          } else if (this.becomeProductArea(row)) {
            row.$selectAll = 1;
          }
        } else if (this.designArea(row)) {
          row.$selectAll = 1;
        } else if (this.carryInfoArea(row)) {
          row.$selectAll = 1;
        } else if (this.becomeProductArea(row)) {
          row.$selectAll = 1;
        } else {
          row.$selectAll = 0;
        }
      } else {
        if (row.$down === 1) {
          this.tableData.forEach(ele => {
            ele.$down = 1;
            ele.$show = 1;
            if (this.designArea(ele)) {
              ele.$selectAll = 1;
            } else if (this.carryInfoArea(ele)) {
              ele.$selectAll = 1;
            } else if (this.becomeProductArea(ele)) {
              ele.$selectAll = 1;
            }
          });
        } else {
          this.tableData.forEach(ele => {
            ele.$down = 0;
            ele.$selectAll = 0;
          });
        }
      }
    },
    isSelect(row, value, type) {
      if (!this.checked) {
        if (value === 0) {
          row.$selectAll = 0;
        } else if (this.designArea(row)) {
          row.$selectAll = 1;
        } else if (this.carryInfoArea(row)) {
          row.$selectAll = 1;
        } else if (this.becomeProductArea(row)) {
          row.$selectAll = 1;
        }
      } else {
        if (value === 0) {
          this.tableData.forEach(ele => {
            ele[type] = 0;
            ele.$selectAll = 0;
          });
        } else {
          this.tableData.forEach(ele => {
            ele[type] = 1;
            if (this.designArea(ele)) {
              ele.$selectAll = 1;
            } else if (this.carryInfoArea(ele)) {
              ele.$selectAll = 1;
            } else if (this.becomeProductArea(ele)) {
              ele.$selectAll = 1;
            }
          });
        }
      }
    },
    // 设计区
    designArea(row) {
      const ischeck =
        row.$show === 1 &&
        row.$down === 1 &&
        row.fileNew === 1 &&
        row.folderNew === 1 &&
        row.fileDel === 1 &&
        row.isSubmit === 1 &&
        row.isPlaceFile === 1 &&
        row.isPrint === 1 &&
        row.isPriviSet === 1 &&
        row.priviAll === 1 &&
        row.isSnapshot === 1;
      const isdesign = this.roleType == "1630981681702" || this.roleType == "1";
      return ischeck && isdesign;
    },
    // 提资区
    carryInfoArea(row) {
      const ischeck = row.$show === 1 && row.$down === 1 && row.folderNew === 1 && row.fileDel === 1 && row.isPriviSet === 1 && row.priviAll === 1 && row.isSnapshot === 1;
      const isdesign = this.roleType == "1630981803194" || this.roleType == "2";
      return ischeck && isdesign;
    },
    // 成品区
    becomeProductArea(row) {
      const ischeck =
        row.$show === 1 &&
        row.$down === 1 &&
        row.fileNew === 1 &&
        row.folderNew === 1 &&
        row.fileDel === 1 &&
        row.isPrint === 1 &&
        row.isPriviSet === 1 &&
        row.priviAll === 1 &&
        row.isSnapshot === 1;
      const isdesign = this.roleType == "1630981811371" || this.roleType == "3";
      return ischeck && isdesign;
    },
    cellStyle({ columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "background: #F7F9FF";
      }
    }

  }
};
</script>

<style lang="less" scoped>
::v-deep .el-table__empty-block {
  border-bottom: 1px solid #EBEEF5;
}
</style>
